const { host } = window.location;

const protocol = 'https';

const serviceType = {
  api: '',
};
const hostApi = 'api.lunch.team';

const currentHost = () => {
  return `${protocol}://${host}`;
};

const currentServerHost = () => {
  return `${protocol}://${hostApi}`;
};

function server(service, path = '') {
  return `${currentServerHost()}${service}${path}`;
}

export default {
  api: path => server(serviceType.api, path),
  currentHost: currentHost,
};



// WEBPACK FOOTER //
// ./src/config/fetch/serverURL.js